import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { BorrowerPair, SendOptions } from '../../types/disclosures';
import { formatClockTime } from '../../utils/format';
interface SendSuccessPanelProps {
  pair: BorrowerPair;
  options: SendOptions;
  documentCount: number;
  onDone: () => void;
  onViewHistory: () => void;
}
export function SendSuccessPanel({
  pair,
  options,
  documentCount,
  onDone,
  onViewHistory
}: SendSuccessPanelProps) {
  const recipients = pair.recipients.filter(recipient => options.recipientIds.includes(recipient.id));
  const names = recipients.map(recipient => recipient.name);
  const nameSentence = names.length > 1 ? `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}` : names[0];
  return <>
      <div className="flex-1 overflow-y-auto px-6 py-8" data-id="element-373" data-mp="295f7nfuxbqt">
        <div className="flex flex-col items-center text-center" data-id="element-374" data-mp="g7c5aheke7fx">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50 ring-1 ring-emerald-100" data-id="element-375" data-mp="b7zgvs81osb8">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-emerald-500 text-white" data-id="element-376" data-mp="38egd8pk4ybqp">
              <CheckIcon className="h-5 w-5" strokeWidth={3} data-id="element-377" data-mp="3dd1f0tf1d3h9" />
            </span>
          </span>
          <h3 className="mt-4 text-[17px] font-semibold tracking-[-0.01em] text-slate-900" data-id="element-378" data-mp="3iat2nb8ne3fn">
            Initial Disclosures Sent
          </h3>
          <p className="mt-1.5 max-w-sm text-[13.5px] leading-5 text-slate-500" data-id="element-379" data-mp="3rcajwwxskb5x">
            {nameSentence} {recipients.length > 1 ? 'have' : 'has'} been sent their disclosure
            package.
          </p>
        </div>

        <dl className="mt-6 divide-y divide-slate-100 rounded-lg border border-slate-200" data-id="element-380" data-mp="4w6dbh9z5p4r">
          <Row label="Sent" data-id="element-381" data-mp="9wat15326ftx">Today at {formatClockTime()}</Row>
          <Row label="Recipients" data-id="element-382" data-mp="9xvl8o1whmom">
            <span className="block space-y-0.5" data-id="element-383" data-mp="dxwc5866rqck">
              {names.map(name => <span key={name} className="block" data-id="element-384" data-mp="iw7lziwhe0us">
                  {name}
                </span>)}
            </span>
          </Row>
          <Row label="Delivery" data-id="element-385" data-mp="2f05af7sqzs9r">
            {options.delivery === 'electronic' ? 'Electronic' : 'Paper / Fulfillment'}
          </Row>
          <Row label="Documents" data-id="element-386" data-mp="2aw7e14ut4vke">{documentCount}</Row>
        </dl>
      </div>

      <div className="flex items-center justify-between gap-3 border-t border-slate-200 bg-slate-50/80 px-6 py-4" data-id="element-387" data-mp="2oqq9sxg8x0tq">
        <button type="button" onClick={onViewHistory} className="rounded-md px-2 py-1 text-[13px] font-medium text-blue-700 transition hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500" data-id="element-388" data-mp="2jwvo5oh2ybs0">
          View Disclosure History
        </button>
        <button type="button" onClick={onDone} className="rounded-md bg-slate-900 px-4 py-2.5 text-[13px] font-semibold text-white transition hover:bg-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2" data-id="element-389" data-mp="32p6md50shljs">
          Done
        </button>
      </div>
    </>;
}
function Row({
  label,
  children
}: {
  label: string;
  children: React.ReactNode;
}) {
  return <div className="flex items-start justify-between gap-4 px-4 py-2.5" data-id="element-390" data-mp="3owahfuovyocf">
      <dt className="text-[12.5px] text-slate-500" data-id="element-391" data-mp="3b70a4rz4cqg7">{label}</dt>
      <dd className="text-right text-[13px] font-medium text-slate-900" data-id="element-392" data-mp="3b4e1sq4em6wx">{children}</dd>
    </div>;
}